import React from 'react';
import PropTypes from 'prop-types';
import { AutoSizer, InfiniteLoader, List } from 'react-virtualized';
import { Box, CircularProgress, Flex } from '@chakra-ui/react';

const InfinityList = ({
  items,
  visibleItemCount,
  itemOverallCount,
  rowHeight,
  rowSpacing,
  getRowHeight,
  loading,
  onRenderRow,
  onLoad,
  loadThreshold,
}) => {
  const overallRowHeight = rowHeight + rowSpacing;
  const listHeight = overallRowHeight * visibleItemCount;
  const onLoadProducts = loading ? () => {} : onLoad;

  return (
    <Box width="100%">
      <Box height={listHeight} width="100%">
        <InfiniteLoader
          isRowLoaded={({ index }) => !!items[index]}
          loadMoreRows={({ startIndex, stopIndex }) => onLoadProducts(startIndex, stopIndex)}
          rowCount={itemOverallCount || 1000}
          minimumBatchSize={visibleItemCount}
          threshold={loadThreshold}
        >
          {({ onRowsRendered, registerChild }) => (
            <AutoSizer>
              {({ width, height }) => {
                return (
                  <List
                    // className={classes.list}
                    height={height}
                    width={width}
                    onRowsRendered={onRowsRendered}
                    ref={registerChild}
                    rowCount={items.length}
                    rowHeight={getRowHeight || overallRowHeight}
                    rowRenderer={onRenderRow}
                  />
                );
              }}
            </AutoSizer>
          )}
        </InfiniteLoader>
        <Flex alignItems="center" justifyContent="center" position="absolute" left="50%" mb={1}>
          {loading === true && <CircularProgress isIndeterminate size={8} />}
        </Flex>
      </Box>
    </Box>
  );
};

InfinityList.propTypes = {
  items: PropTypes.array.isRequired,
  onRenderRow: PropTypes.func.isRequired,
  rowHeight: PropTypes.number,
  getRowHeight: PropTypes.func,
  rowSpacing: PropTypes.number,
  onLoad: PropTypes.func,
  visibleItemCount: PropTypes.number,
  itemOverallCount: PropTypes.number,
  loading: PropTypes.bool,
  loadThreshold: PropTypes.number,
};

InfinityList.defaultProps = {
  onLoad: () => {},
  rowHeight: 60,
  rowSpacing: 0,
  visibleItemCount: 10,
  itemOverallCount: 10,
  loading: false,
  getRowHeight: null,
  loadThreshold: 15,
};

export default InfinityList;
